import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const EntryPoint = React.lazy(() => import("../../containers/TermsMarketing/EntryPointContainer"));

export const termsMarketingRoutes: RouteObject[] = [
    {
        title: "TermsMarketing",
        path: "/terminos-y-condiciones-marketing",
        component: <EntryPoint />
    }
];